export const AdvertisementStatus = {
    WAITING_APPROVE: 'WAITING_APPROVE',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED'
}